export default __webpack_public_path__ + "static/media/segre20.0569b584.jpg";